import dataStore from '../functions/dataStore'
import serverFunctions from "@/functions/serverFunctions";


var userFunctions = {
	getLoggedInUser() {
		return dataStore.getCurrentUser();
	},
	getUnreadMessageCount() {
		return dataStore.getUnreadMessageCount();
	},
	getNewNews() {
		return dataStore.getNewNews();
	},
	getNewJournals() {
		return dataStore.getNewJournals();
	},
	getNewLinks() {
		return dataStore.getNewLinks();
	},
	getNewTopicPosts() {
		return dataStore.getNewTopicPosts();
	},
	getNewNurseries() {
		return dataStore.getNewNurseries();
	}, 
	userIsLoggedIn() {
		return dataStore.loggedIn;
	},
	getFullAvatarUrl(filePathAndName) {
		//TODO remove this logic when all avatars have been migrated
		if (filePathAndName) {
			return filePathAndName.slice(0, 13) == "user-content/"
				? process.env.VUE_APP_AVATAR_BASE_URL_NEW + filePathAndName
				: process.env.VUE_APP_AVATAR_BASE_URL_OLD + filePathAndName;
		}
		return null;
	},
	currentUserIsOwner() {
		if (!dataStore.loggedIn) {
			return false;
		}
		let isOwner = dataStore.getCurrentUser().isOwner;
		return (isOwner == 1);
	},
	currentUserIsModerator() {
		if (!dataStore.loggedIn) {
			return false;
		}
		let isModerator = dataStore.getCurrentUser().isModerator;
		return (isModerator == 1);
	},
	async updateUnreadMessageCount() {
		let user = this.getLoggedInUser();
		if (!user) { return; }
		const unreadMessageCountRequest = serverFunctions.getDataRequestObject(
			user
		);
		let serverResponse = await serverFunctions.getPostResponse("/getUnreadMessageCount", unreadMessageCountRequest);

		if (serverResponse && serverResponse.length == 1) {
			dataStore.setUnreadMessageCount(serverResponse[0].unreadMessageCount);
			dataStore.setNewNews(serverResponse[0].unreadNews);
			dataStore.setNewNurseries(serverResponse[0].unreadNurseries);
			dataStore.setNewJournals(serverResponse[0].unreadJournals);
			dataStore.setNewLinks(serverResponse[0].unreadLinks);
			dataStore.setNewTopicPosts(serverResponse[0].unreadTopicPosts);
		}
	},
	async updateLastViewed(activity) {

		let deviceId = dataStore.getDeviceId()

		let user = this.getLoggedInUser();

		const updateLastViewedRequest = serverFunctions.getUpdateLastViewedRequest(
			user,
			deviceId,
			activity
		);
		serverFunctions.getPostResponse("/updateLastViewed", updateLastViewedRequest);
	},

	async login(email, password) {

		const userLoginDetails = { "email": email, "password": password };

		const loginResult = await fetch(
			process.env.VUE_APP_SERVER_URL + "/login",
			{
				method: "post",
				body: JSON.stringify(userLoginDetails),
			}
		);
		const data = await loginResult.json();
		const userLoginResult = data.result;

		if (!userLoginResult || userLoginResult.length != 1) {
			this.logout();
			return data.failureReason;
		}

		const user = userLoginResult[0];

		if (user.token && user.token.length > 0) {
			// store user details and jwt token in local storage to keep user logged in between page refreshes
			// dataStore.currentUser = user
			dataStore.setCurrentUser(user);
			this.updateLastViewed('login')
		}

	},
	logout() {
		// remove user from local storage to log user out
		// localStorage.removeItem('user');
		this.updateLastViewed('logout')
		dataStore.setCurrentUser(null);
	},
	setuser(user) {
		if (user.token && user.token.length > 0) {
			// store user details and jwt token in local storage to keep user logged in between page refreshes
			// dataStore.currentUser = user
			dataStore.setCurrentUser(user);
		}
	}
}

export default userFunctions